import apiClient from './apiClient';

// Get Profile
export const getProfileApi = async (almataId) => {
  const response = await apiClient.get(`/partners/almata-partners/${almataId}`);
  return response.data;
};

// Change Password
export const changePasswordApi = async (data) => {
  const response = await apiClient.patch('/partners/almata-partners/change-password', data);
  return response.data;
};

// Update Logo
export const updateLogoApi = async (formData) => {
  const response = await apiClient.patch('/partners/almata-partners/logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update Profile
export const updateProfileApi = async (data) => {
  const response = await apiClient.patch('/partners/almata-partners/profile', data);
  return response.data;
};

// Verify Email
export const verifyEmailApi = async (data) => {
  const response = await apiClient.post('/partners/almata-partners/verify-mail', data);
  return response.data;
};